import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    CcComplianceProps,

    LoadCcLibraryItemById,
    LoadCcComplianceItemState,
    LoadCcComplianceHistory,
    LoadCcComplianceTempAnswers,
    LoadCcComplianceTempAnswerVersions,

    setCcComplianceItemDetails,
    setCcComplianceItemState,
    setCcComplianceItemHistory,
    setCcComplianceTempAnswers,
    setCcComplianceTempAnswerVersions,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Details from "./details"
import History from "./history"
import AnswerForm from "./form"

interface ComplianceAnswerProps extends CcComplianceProps {}

const ComplianceAnswer = ({
    setId,
    revisionId,
    itemId,
}: ComplianceAnswerProps) => {
    const item = useSelector((state: StoreType) => state.ccCompliance.itemDetails)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        Promise.all([
            LoadCcLibraryItemById(itemId, setId).then((res) => {
                dispatch(setCcComplianceItemDetails(res))
            }),
            LoadCcComplianceItemState(itemId, revisionId).then((res) => {
                dispatch(setCcComplianceItemState(res))
            }),
            LoadCcComplianceHistory(itemId, revisionId).then((res) => {
                dispatch(setCcComplianceItemHistory(res))
            }),
            LoadCcComplianceTempAnswers(itemId, revisionId).then((res) => {
                dispatch(setCcComplianceTempAnswers(res))
            }),
            LoadCcComplianceTempAnswerVersions(itemId, revisionId).then((res) => {
                dispatch(setCcComplianceTempAnswerVersions(res))
            }),
        ]).then(() => {
            setLoadState(IDLE)
        })
    }, [])

    if (!item) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.editAnswer}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }

                <Details />
                <History />
                <AnswerForm />
            </PageContent>
        </Container>
    )
}
export default ComplianceAnswer
